import { useTRPC } from "@/lib/trpc";
import { useQuery } from "@tanstack/react-query";

export default function MobileHome() {
  const trpc = useTRPC();

  // Fetch the feed data using the new postables.feed.list endpoint
  const {
    data: feedData,
    isLoading: isFeedLoading,
    isError: isFeedError,
  } = useQuery(trpc.postables.feed.queryOptions());

  if (isFeedLoading) {
    return <div>Loading feed...</div>;
  }

  if (isFeedError) {
    return <div>Error loading feed</div>;
  }

  return (
    <div>
      <h1>Feed</h1>
      {feedData && Array.isArray(feedData) && feedData.length > 0 ? (
        <div>
          {feedData.map((category) => (
            <div key={category.id} className="mb-6">
              <h2 className="text-xl font-bold mb-2">{category.title}</h2>
              <div className="flex flex-wrap gap-4">
                {category.postables.map((postable) => (
                  <div key={postable.postableId} className="border p-4 rounded">
                    <p>Type: {postable.postableType}</p>
                    {postable.postable.id && (
                      <p className="font-bold">{postable.postable.id}</p>
                    )}
                    {postable.postable.id && (
                      <p className="font-bold">{postable.postable.id}</p>
                    )}
                    {postable.postable.id && (
                      <p className="text-sm">{postable.postable.id}</p>
                    )}
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>
      ) : (
        <div>No feed items found</div>
      )}
    </div>
  );
}
